import React from 'react';
import ResultsCard from 'bayesian-estimation-web/app/components/Model/SingleBayesianModelView/Results/ResultsCard';
import {Dialog, DialogActions} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import CancelButton from "hcla-web-frontend-primitives/app/components/primitives/Buttons/CancelButton";
import ReferenceTypes from "../../mxGraph/HCLTreeNode/HCLTreeVertexValue/ReferenceTypes";

const BayesianEstimationResultsDialog = (props) => {
	const { priorDist, priorType, priorValues, isQuantificationInProgress, points, results, save, close, basicEvent, treeData } = props;
	const saveTree = (e) => {
		const newBasicEvent = {...treeData[ReferenceTypes.BASIC_EVENTS][basicEvent.key]}
		if (results.result_data.mean && results.result_data.variance) {
			newBasicEvent.expression.mean = results.result_data.mean;
			newBasicEvent.expression.std = results.result_data.variance;
			newBasicEvent.expression._params = [ "mean", "std" ];
		}
		if (results.result_data.upper_bound && results.result_data.lower_bound) {
			newBasicEvent.expression.p5 = results.result_data.p5;
			newBasicEvent.expression.p95 = results.result_data.p95;
			newBasicEvent.expression._params = ["p5", "p95"];
		}
		treeData[ReferenceTypes.BASIC_EVENTS][basicEvent.key] = newBasicEvent
		save(e, treeData);
	}

	return (
		<Dialog
			open={true}
			fullWidth
			maxWidth={false}
			onClose={close}
		>
			<DialogTitle>
				Bayesian Estimation Results
			</DialogTitle>
			<DialogContent>
				<ResultsCard
					priorDist={priorDist}
					priorType={priorType}
					priorValues={priorValues}
					isQuantifying={isQuantificationInProgress}
					// isLoading={this.state.isQuantificationLoading}
					points={points}
					data={results}
				/>
			</DialogContent>
			<DialogActions>
				<CancelButton
					variant="outlined"
					size="large"
					onClick={close}
				>
					Close
				</CancelButton>
				<Button
					color={"primary"}
					variant={"contained"}
					size={"large"}
					onClick={e => saveTree(e)}
				>
					Save to Tree
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default BayesianEstimationResultsDialog;